export default __webpack_public_path__ + "static/media/no-projects-found-board.51a041fc.svg";